import controller from './double-opt-success-dialog.controller';

export default {
  controller,
  template: require('./double-opt-success-dialog.html')
};



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/success/double-opt-success-dialog.component.ts